/**
 * <ErrorText> — la ligne qui dit une erreur (atom).
 *
 * Petite, en rouge, posée là où l'erreur s'applique : sous un champ, ou près du geste qu'elle
 * refuse. `live` l'annonce aux lecteurs d'écran quand elle apparaît — pour une erreur qui arrive
 * du serveur après un geste, pas pour une validation que la personne vient de provoquer en tapant.
 */
import React from "react"
import { View } from "react-native"

import { Text } from "../Text"

export type ErrorTextProps = {
    children: React.ReactNode
    center?: boolean
    /** Annonce la ligne quand elle apparaît. Défaut `false`. */
    live?: boolean
    testID?: string
}

export function ErrorText(props: ErrorTextProps) {
    const { children, center = false, live = false, testID } = props
    const line = (
        <Text testID={testID} size="text-sm" color="text-danger" center={center}>
            {children}
        </Text>
    )

    return live ? <View accessibilityLiveRegion="polite">{line}</View> : line
}
